"use strict";
exports.__esModule = true;
exports.getInitialIsSet = void 0;
exports.getInitialIsSet = function (data) {
    if ((data === null || data === void 0 ? void 0 : data.country) && (data === null || data === void 0 ? void 0 : data.city) && (data === null || data === void 0 ? void 0 : data.street) && (data === null || data === void 0 ? void 0 : data.zip)) {
        return true;
    }
    return false;
};
